import { formatCents } from "@caloteiros/shared";
import type { PixKeyType } from "@caloteiros/shared";
import { PIX_KEY_TYPE_LABELS } from "@caloteiros/shared";

export { formatCents };

/** "R$ 1.234,56" sem o sinal — o sinal vira cor e palavra na interface. */
export function formatAbs(cents: number): string {
  return formatCents(Math.abs(cents));
}

const dayFormatter = new Intl.DateTimeFormat("pt-BR", {
  weekday: "long",
  day: "2-digit",
  month: "long",
});

const shortFormatter = new Intl.DateTimeFormat("pt-BR", { day: "2-digit", month: "2-digit" });

function startOfDay(date: Date): number {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
}

/** "Hoje", "Ontem" ou "sexta-feira, 12 de setembro". */
export function formatDayLabel(iso: string): string {
  const date = new Date(iso);
  const diffDays = Math.round((startOfDay(new Date()) - startOfDay(date)) / 86_400_000);
  if (diffDays === 0) return "Hoje";
  if (diffDays === 1) return "Ontem";
  return dayFormatter.format(date);
}

export function formatShortDate(iso: string): string {
  return shortFormatter.format(new Date(iso));
}

/** Para o <input type="date">, que so aceita AAAA-MM-DD. */
export function toDateInputValue(iso: string): string {
  const date = new Date(iso);
  const month = `${date.getMonth() + 1}`.padStart(2, "0");
  const day = `${date.getDate()}`.padStart(2, "0");
  return `${date.getFullYear()}-${month}-${day}`;
}

/**
 * O caminho de volta do <input type="date"> para ISO. Fixa meio-dia local de
 * proposito: 00:00 vira o dia anterior quando o fuso do Brasil e aplicado.
 */
export function fromDateInputValue(value: string): string {
  const [year, month, day] = value.split("-").map(Number);
  if (!year || !month || !day) return new Date().toISOString();
  return new Date(year, month - 1, day, 12, 0, 0).toISOString();
}

/** Duas letras para o avatar: "João Pedro" vira "JP". */
export function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  const first = parts[0]?.[0] ?? "";
  const last = parts.length > 1 ? (parts[parts.length - 1]?.[0] ?? "") : "";
  return `${first}${last}`.toUpperCase();
}

export function pixTypeLabel(type: PixKeyType | null): string {
  return type ? PIX_KEY_TYPE_LABELS[type] : "Chave Pix";
}

/** Primeiro nome, que e como as pessoas se chamam num rolê. */
export function firstName(name: string): string {
  return name.trim().split(/\s+/)[0] ?? name;
}
